import { render, staticRenderFns } from "./EditCategoryContactsPage.vue?vue&type=template&id=b712a976&scoped=true&"
import script from "./EditCategoryContactsPage.vue?vue&type=script&lang=js&"
export * from "./EditCategoryContactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b712a976",
  null
  
)

export default component.exports